import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import Tools from "@/shared/services/tools";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import PedidoDetalhesViewModel from "@/shared/view-models/PedidoDetalhesViewModel";
import GerarNovoPedidoCaracteristicasViewModel from "@/shared/view-models/GerarNovoPedidoCaracteristicasViewModel";
import novaEmbalagemViewModel from "@/shared/view-models/Filtros/NovaEmbalagemViewModel";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";
const name = 'DetalhesPedidoExpedidoFaturado'

export default {
  name,

  components:{ 
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    PedidoEmAndamentoPDF
  },

  props: { },

  mounted() { 
    // this.getDetalhesPedido()
    this.getDetalhesDoPedido()
    this.getDetalhesGeraisDoPedido()
    this.getCaracteristicasDoGerarNovoPedido()
    this.getLogDetalhesExpedidoFaturado()

  },

  updated() { },

  data() {
    return { 
      executarvisualizacao: 0,
      linhaSelecionada: {},
      embalagensArray:[],
      PedidoId: null,
      renderiza: false,
      detalhesArray: [],
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
      novoPedidoDetalhes : new PedidoDetalhesViewModel(),
      novaEmbalagem : new novaEmbalagemViewModel(),
      caracteristicasPedido : new GerarNovoPedidoCaracteristicasViewModel(),
      ComponentePedidoArray: [],
      ObsArray: [],
      podeGerarPdf: false,
    }
  },

  methods: { 
    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },
    
    voltar() {
      this.$router.push(`/pedido-expedido-faturado`);
    },

    imprimir() {  
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      
      if(this.podeGerarPdf) {
        this.executarvisualizacao++
      }
    },

    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++
      }, "500");
    },

    getDetalhesPedido () {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesPedidosExpedidosFaturados/${this.$route.params.id}`,
      })
      .then((response) => {
        this.detalhesArray = response.data.data
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    getDetalhesDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
        })
        .catch(() => {
        });
    },

    getLogDetalhesExpedidoFaturado() {
      this.axios({
        method: "get",
        url: 
          process.env.VUE_APP_WEB_API +
          `Pedido/getLogDetalhesExpedidoFaturado/`
        }).then(() => {

        })
    },


    getDetalhesGeraisDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesGeraisDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.novoPedidoDetalhes, Tools.captalizeKeys(response.data.data))
          this.OrcamentoIdCerto = this.novoPedidoDetalhes.OrcamentoId;

          this.novoPedidoDetalhes.ImpressaoDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.ImpressaoDescricao) : ''
          this.novoPedidoDetalhes.DescricaoVisual !== null ? this.ObsArray.push(this.novoPedidoDetalhes.DescricaoVisual) :''
          this.novoPedidoDetalhes.FacaMedidaDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.FacaMedidaDescricao) : ''
          this.novoPedidoDetalhes.FacaSistemaDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.FacaSistemaDescricao) :''
          this.InformacoesOrcamentoComponenteByOrcamentoId();
          // this.getEmbalagemColetiva()

        })
        .catch(() => {
        });
    },

    getCaracteristicasDoGerarNovoPedido() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetCaracPedidoFluxo/${this.$route.params.id}`,
        data: {
          PedidoId: this.$route.params.id
        }
      })
        .then((response) => {
          Tools.objectCustomAssign(this.caracteristicasPedido, Tools.captalizeKeys(response.data.data))
        }).finally(() => this.$isLoading(false))
    },

    InformacoesOrcamentoComponenteByOrcamentoId(){
      // let PedidoId = this.$route.params.id
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByOrcamentoId/${this.OrcamentoIdCerto}`,
      })
      .then((response) => {
        this.ComponentePedidoArray = response.data.data
        this.novaEmbalagem = response.data.data
        this.embalagensEspecificas()
        this.ComponentePedidoArray.forEach((r)=>{
          r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
          return this.ColunaMedidas = r.ColunaMedidas
        })
      })
      .catch(() => {
      });
    },

    embalagensEspecificas(){
      this.ComponentePedidoArray.forEach((r)=>{
        r.embalagens = []
        r.embalagemEspecificaFilmeEncolhivel ? r.embalagens.push('Filme encolhível: ' + `${r.quantidadeFilmeEncolhivel}`) : ''
        r.embalagemEspecificaCaixaColetiva ? r.embalagens.push('Caixa Coletiva: ' + `${r.quantidadeCaixaColetiva}`) : ''
        r.embalagemEspecificaPalete  ? r.embalagens.push('Palete: ' + `${r.quantidadePalete}`) : ''
        r.embalagemEspecificaPapelEmbrulho  ? r.embalagens.push('Papel Embrulho: ' + `${r.quantidadePapelEmbrulho}`) : ''
        r.quantidadeOutros ? r.embalagens.push('Outros: ' + `${r.quantidadeOutros}`) : ''

  })
  },

  getEmbalagemColetiva() {
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByOrcamentoId/${this.OrcamentoId}`,
    })
      .then((response) => {
        Tools.objectCustomAssign(this.novaEmbalagem, Tools.captalizeKeys(response.data.data))
        this.OrcamentoId = this.novaEmbalagem.OrcamentoId;
        this.InformacoesOrcamentoComponenteByOrcamentoId();
      })
  },
  },

  computed: { }
};